import currencies from './currencies';
import countries from './countries';

export const DEFAULT_CURRENCY = 'USD';

export const EMAIL_REGEX = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const LOADER_DELAY = 750;

// how long before we apologise for being slow
export const LOADER_SLOW = 10000;

export const MOBILE_MAX_WIDTH = 720;

export const POST_LOADER_DELAY = LOADER_DELAY + 500;

export const S3_BUCKET_URL = 'https://pleatt-assets.s3-eu-west-1.amazonaws.com';

export {
  currencies,
  countries,
};
